export const BUTTON_ARROW_CONTENT_ICON_PLACEMENT_BEFORE = 'beforeContent'

export const BUTTON_ARROW_CONTENT_ICON_PLACEMENT_AFTER = 'afterContent'
